import React, { useEffect, useRef, useState } from "react";
import AirDatepicker from "air-datepicker";
import "air-datepicker/air-datepicker.css";
import en from "air-datepicker/locale/en";
import "./AirDatepickerStyles.css";

type dateProps = {
  startDate: Date;
  endDate: Date;
  onSelectDate: (
    date: Date | Date[],
    formattedDate: string | string[],
    isDateSelected: boolean
  ) => void;
  isThisWeek?: boolean;
  handleOnAllAvailableSelected: () => void;
  handleOnAllNotAvailableSelected: () => void;
  preSelectedDates?: string[];
  viewDate?: Date;
};

export const AirDatepickerReact: React.FC<dateProps> = ({
  startDate,
  endDate,
  onSelectDate,
  isThisWeek,
  handleOnAllAvailableSelected,
  handleOnAllNotAvailableSelected,
  preSelectedDates,
  viewDate,
}) => {
  const [selectedDates, setSelectedDates] = useState<string[]>([]);
  const inputRef = useRef(null);
  const dpRef = useRef<AirDatepicker>();

  const allWeekAvailable = {
    content: "Available ✓",
    className: "all-week-available",
    onClick: (dp: {
      selectDate: (arg0: Date) => void;
      setViewDate: (arg0: Date) => void;
    }) => {
      handleOnAllAvailableSelected();
    },
  };

  const allWeekNotAvailable = {
    content: "Unavailable ✗",
    className: "all-week-not-available",
    onClick: (dp: {
      selectDate: (arg0: Date) => void;
      setViewDate: (arg0: Date) => void;
    }) => {
      handleOnAllNotAvailableSelected();
    },
  };

  useEffect(() => {
    if (inputRef.current) {
      // Initialize AirDatepicker instance
      dpRef.current = new AirDatepicker(inputRef.current, {
        inline: true,
        locale: en,
        multipleDates: true,
        minDate: startDate,
        maxDate: endDate,
        disableNavWhenOutOfRange: true,
        buttons: [allWeekAvailable, allWeekNotAvailable],
        selectedDates: preSelectedDates ? [...preSelectedDates] : [],
        dateFormat: "yyyy-MM-dd",
        navTitles: {
          days: "<span style='color: #0A4D43; font-weight: 600; pointer-events: none;'>MMMM yyyy</span>",
        },
        onRenderCell({ date, cellType }) {
          if (cellType === "day") {
            const today = new Date();
            today.setHours(0, 0, 0, 0); // Set today's date to midnight for accurate comparison

            if (
              (date < startDate || date > endDate) &&
              date.getTime() !== today.getTime()
            ) {
              return {
                disabled: true,
                classes: "-disabled-",
              };
            }
          }
        },
        onSelect({ date, formattedDate, datepicker }) {
          // if (!formattedDate) {
          //   setSelectedDates([]);
          //   onSelectDate(date, formattedDate, false);
          //   return;
          // }

          // if (isAllDatesSelected) {
          //   setSelectedDates([]);
          //   setIsAllDatesSelected(false);
          // }

          const preSelectedDate = preSelectedDates?.find(
            (preDate) => !formattedDate.includes(preDate)
          );

          if (preSelectedDate) {
            setSelectedDates([]);
            onSelectDate(date, preSelectedDate, true);
            return;
          }

          // let isDateSelected = false;

          // if (
          //   selectedDates?.length === 0 &&
          //   typeof formattedDate === "string"
          // ) {
          //   isDateSelected = true;
          // } else if (selectedDates?.length < formattedDate?.length) {
          //   isDateSelected = true;
          // }

          // const newDatesArray = [formattedDate[formattedDate.length - 1]];

          // setSelectedDates(newDatesArray);
          // onSelectDate(
          //   date,
          //   formattedDate[formattedDate.length - 1]?.replaceAll("/", "-"),
          //   isDateSelected
          // );
          onSelectDate(
            date,
            formattedDate[formattedDate.length - 1]?.replaceAll("/", "-"),
            true
          );
        },
      });

      if (viewDate) {
        dpRef.current.setViewDate(viewDate);
      }
    }

    return () => {
      // Cleanup on component unmount
      if (dpRef.current) {
        dpRef.current.destroy();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate, selectedDates, preSelectedDates, viewDate]);

  return <div ref={inputRef} />;
};
